/**
 * Skidata writes the area into the gate name: "Eingang A - Sitzplatz".
 * The client reads these at a glance and asked for the area shortened, so the
 * suffix becomes "SP". Only the display is shortened — the stored value stays
 * exactly as the barrier reported it, which is what we compare against when
 * their labels change.
 */
const formatGate = (gate) => (gate || '').replace(/\s*-\s*Sitzplatz\s*$/i, ' - SP');

export default formatGate;
